// extracted by mini-css-extract-plugin
export default {"logo":"BackCover-module__logo__TlByQ"};